<template>
    <AppLayout
        page="/dashboard"
        pageTitle="Founders Memberships"
        backLink="/dashboard/reports"
    >
        <v-col cols="12" class="pa-1">
            <Stats class="pb-3" :stats="stats" />
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <ReportHeader
                        filter
                        reportUrl="/dashboard/reports/founders-memberships"
                        @search="search = $event"
                    />
                    <v-data-table
                        ref="table"
                        :headers="headers"
                        :items="founders"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        :search="search"
                        @current-items="collapse()"
                        @click:row="[$log($event.id)]"
                    >
                        <template
                            v-slot:[`group.header`]="{
                                group,
                                items,
                                isOpen,
                                toggle,
                            }"
                        >
                            <th colspan="8">
                                <v-row
                                    no-gutters
                                    class="flex justify-start align-center pa-2"
                                >
                                    <v-icon @click="toggle" class="mr-3"
                                        >{{ isOpen ? "remove" : "add" }}
                                    </v-icon>
                                    <v-col>
                                        <div
                                            class="soli-grey text-subtitle-2 font-weight-bold"
                                        >
                                            {{ group }}
                                        </div>
                                        <div class="soli-grey text-small">
                                            • {{ items.length }} Lead(s)
                                        </div>
                                    </v-col>
                                </v-row>
                            </th>
                        </template>
                        <template v-slot:[`item.info.name`]="{ item }">
                            <div class="d-flex align-center py-2 soli-grey">
                                <div>
                                    <Link
                                        v-if="item.info.user_id"
                                        :href="`/profile/${item.info.user_id}/account`"
                                    >
                                        <v-list-item-title>
                                            {{ item.info.name }}
                                        </v-list-item-title>
                                    </Link>
                                    <v-list-item-title v-else>
                                        {{ item.info.name }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ item.info.email }}
                                        <Clipboard
                                            v-if="item.info.email"
                                            :text="item.info.email"
                                            label="Copy Email"
                                            x-small
                                        />
                                    </v-list-item-subtitle>
                                </div>
                            </div>
                        </template>
                    </v-data-table>

                    <!--<template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" class="ma-3">
                            <div class="ma-3">test</div>
                        </td></template
                    >-->
                </v-container>
            </v-card>
        </v-col>
        <!--<SoliResponsiveDialog
            v-if="showLeadDetails"
            @reset="showLeadDetails = null"
            :title="showLeadDetails.info.name"
            ><template #body>
                <v-list-item dense class="soli-grey px-2"
                    ><b>Email:</b>&nbsp{{ showLeadDetails.info.email }}
                </v-list-item>
                <v-list-item dense class="soli-grey px-2"
                    ><b>Phone:</b>&nbsp{{ showLeadDetails.info.phone }}
                </v-list-item>
                <v-list-item dense class="soli-grey px-2"
                    ><b>Where:</b>&nbsp{{ showLeadDetails.where }}
                </v-list-item>
                <v-list-item dense class="soli-grey px-2"
                    ><b>Instrument:</b>&nbsp{{ showLeadDetails.instrument }}
                </v-list-item>
                <v-list-item dense class="soli-grey px-2"
                    ><b>Program:</b>&nbsp{{ showLeadDetails.program }}
                </v-list-item>
            </template></SoliResponsiveDialog
        >-->
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import ReportHeader from "../../Components/Reports/ReportHeader.vue";
import Stats from "../../Components/Reports/Stats.vue";
import Clipboard from "../../Components/Clipboard.vue";

export default {
    props: {
        founders: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        AppLayout,
        Link,
        ReportHeader,
        Stats,
        Clipboard,
    },
    data() {
        return {
            search: "",
            showMessage: false,
            expanded: [],
            headers: [
                {
                    text: "Founder",
                    align: "start",
                    sortable: true,
                    value: "info.name",
                },
                {
                    text: "Membership",
                    align: "start",
                    sortable: true,
                    value: "membership",
                    width: "200px",
                },
                {
                    text: "Instrument",
                    align: "start",
                    sortable: true,
                    value: "instrument",
                },
                {
                    text: "Source",
                    align: "start",
                    sortable: true,
                    value: "source",
                },
                {
                    text: "Promo",
                    align: "start",
                    sortable: true,
                    value: "promo",
                },
                {
                    text: "Campaign",
                    align: "start",
                    sortable: true,
                    value: "campaign_name",
                },
                {
                    text: "Purchase Date",
                    align: "start",
                    sortable: true,
                    value: "date",
                },
            ],
            showLeadDetails: null,
        };
    },
    computed: {
        stats() {
            return [
                {
                    title: "Founders",
                    data: this.founders.length,
                    color: "accent",
                    icon: "waving_hand",
                },
            ];
        },
    },
    methods: {
        collapse() {
            this.$nextTick(() => {
                let obj = this.$refs.table.openCache;
                Object.keys(obj).forEach((e) => (obj[e] = false));
            });
        },
    },
};
</script>
